import(/* webpackMode: "eager" */ "/home/runner/_work/pxp-checkout-v3/pxp-checkout-v3/apps/payments-checkout/app/global-error.tsx");
